export const operatorOptions = [
  { key: 'is', text: 'is', value: 'is', translationKey: 'accessLogsFilterOperatorIs' },
  { key: 'isAnyOf', text: 'is any of', value: 'is any of', translationKey: 'accessLogsFilterOperatorIsAnyOf' },
];

export const columnOptions = [
  { key: 'category', text: 'Category', value: 'category', translationKey: 'accessLogsFilterColumnCategory' },
  { key: 'time', text: 'Time', value: 'time', translationKey: 'accessLogsFilterColumnTime' },
  { key: 'user', text: 'User', value: 'user', translationKey: 'accessLogsFilterColumnUser' },
  { key: 'zone', text: 'Zone', value: 'zone', translationKey: 'accessLogsFilterColumnZone' },
  { key: 'credentials', text: 'Credentials', value: 'credentials', translationKey: 'accessLogsFilterColumnCredentials' },
];

export const categoryOptions = [
  { key: 'Granted', text: 'Granted', value: 'Granted', translationKey: 'accessLogsFilterCategoryGranted' },
  { key: 'Denied', text: 'Denied', value: 'Denied', translationKey: 'accessLogsFilterCategoryDenied' },
  { key: 'Public', text: 'Public', value: 'Public', translationKey: 'accessLogsFilterCategoryPublic' },
  { key: 'Lockout', text: 'Lockout', value: 'Lockout', translationKey: 'accessLogsFilterCategoryLockout' },
];

export const credentialsOptions = [
  { key: 'Bluetooth', text: 'Bluetooth', value: 'Bluetooth', translationKey: 'accessLogsFilterCredentialBluetooth' },
  { key: 'Card', text: 'Card', value: 'Card', translationKey: 'accessLogsFilterCredentialCard' },
  { key: 'FingerPrint', text: 'FingerPrint', value: 'FingerPrint', translationKey: 'accessLogsFilterCredentialFingerPrint' },
  { key: 'Pin', text: 'Pin', value: 'Pin', translationKey: 'accessLogsFilterCredentialPin' },
  { key: 'QrCode', text: 'QrCode', value: 'QrCode', translationKey: 'accessLogsFilterCredentialQrCode' },
  { key: 'Remote', text: 'Remote', value: 'Remote', translationKey: 'accessLogsFilterCredentialRemote' },
  { key: 'Rex', text: 'Rex', value: 'Rex', translationKey: 'accessLogsFilterCredentialRex' },
  { key: 'LicensePlate', text: 'LicensePlate', value: 'LicensePlate', translationKey: 'accessLogsFilterCredentialLicensePlate' },
];
